import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import RestaurantOverviewTab from "./tabs/RestaurantOverviewTab";
import RestaurantSalesOrdersTab from "./tabs/RestaurantSalesOrdersTab";
import RestaurantBranchesTab from "./tabs/RestaurantBranchesTab";
import RestaurantMenuTab from "./tabs/RestaurantMenuTab";
import RestaurantChannelsCustomersTab from "./tabs/RestaurantChannelsCustomersTab";
import { useRestaurantAnalyticsData } from "../hooks/useRestaurantAnalyticsData";
import "./RestaurantAnalyticsTabsDashboard.scss";

type RestaurantTabId = "overview" | "sales" | "branches" | "menu" | "channels";

const RESTAURANT_TAB_ITEMS: { id: RestaurantTabId; labelKey: string; defaultLabel: string }[] = [
  { id: "overview", labelKey: "restaurantAnalytics.tabs.overview", defaultLabel: "Overview" },
  { id: "sales", labelKey: "restaurantAnalytics.tabs.sales", defaultLabel: "Sales & Orders" },
  { id: "branches", labelKey: "restaurantAnalytics.tabs.branches", defaultLabel: "Branches" },
  { id: "menu", labelKey: "restaurantAnalytics.tabs.menu", defaultLabel: "Menu Analytics" },
  { id: "channels", labelKey: "restaurantAnalytics.tabs.channels", defaultLabel: "Channels & Customers" },
];

const RestaurantAnalyticsTabsDashboard: FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<RestaurantTabId>("overview");
  const { filters, setFilter, resetFilters, isFiltered, metrics } = useRestaurantAnalyticsData();

  const headerProps = { filters, setFilter, isFiltered, onReset: resetFilters };

  return (
    <div className="restaurant-analytics-dashboard">
      <div className="restaurant-analytics-dashboard__tabs">
        {RESTAURANT_TAB_ITEMS.map(tab => (
          <button
            key={tab.id}
            type="button"
            className={`restaurant-analytics-dashboard__tab ${activeTab === tab.id ? "restaurant-analytics-dashboard__tab--active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {t(tab.labelKey, { defaultValue: tab.defaultLabel })}
          </button>
        ))}
      </div>

      {activeTab === "overview" ? <RestaurantOverviewTab metrics={metrics} filters={filters} headerProps={headerProps} /> : null}
      {activeTab === "sales" ? <RestaurantSalesOrdersTab metrics={metrics} filters={filters} headerProps={headerProps} /> : null}
      {activeTab === "branches" ? <RestaurantBranchesTab metrics={metrics} filters={filters} headerProps={headerProps} /> : null}
      {activeTab === "menu" ? <RestaurantMenuTab metrics={metrics} filters={filters} headerProps={headerProps} /> : null}
      {activeTab === "channels" ? <RestaurantChannelsCustomersTab metrics={metrics} filters={filters} headerProps={headerProps} /> : null}
    </div>
  );
};

export default RestaurantAnalyticsTabsDashboard;
